webpackJsonp([52],{

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ListOfDetails__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ListOfDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_ListOfDetails__);




var changePage = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(value) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.page = value;
						this.loadData();

					case 2:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changePage(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							limit: this.limit,
							page: this.page
						};

						if (this.search) {
							params.search = this.search;
						}
						if (this.sortField) {
							params.sortField = this.sortField;
						}
						if (this.sortDirection) {
							params.sortDirection = this.sortDirection;
						}
						_context2.next = 6;
						return this.$http.get('//products.japisale.com' + '/p/transfers-minibar', { params: params });

					case 6:
						response = _context2.sent;

						this.totalPages = Number(response.headers.get('x-last-page'));
						this.rows = response.data.map(function (data) {
							var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
							newData.showUndo = true;
							newData.dialog = false;
							if (data.cancelUserId) {
								newData.showUndo = false;
							}
							return newData;
						});

					case 9:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref3.apply(this, arguments);
	};
}();

var loadModalData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
		var id = _ref5.id;
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {};

						if (this.searchToDetail) {
							params.search = this.searchToDetail;
						}
						if (this.sortDirectionToDetail) {
							params.sortDirection = this.sortDirectionToDetail;
						}
						if (this.sortFieldToDetail) {
							params.sortField = this.sortFieldToDetail;
						}
						_context3.next = 6;
						return this.$http.get('//products.japisale.com' + '/p/transfers/' + id + '/minibar', { params: params });

					case 6:
						response = _context3.sent;

						this.modalData = response.data;

					case 8:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadModalData(_x2) {
		return _ref4.apply(this, arguments);
	};
}();

var undoTransfer = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7) {
		var id = _ref7.id,
		    number = _ref7.number;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return this.$http.patch('//products.japisale.com' + '/p/transfers/' + id + '/cancel');

					case 2:
						this.showNotification('La transferencia #' + number + ' ha sido anulada.', 'success');
						this.loadData();

					case 4:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function undoTransfer(_x3) {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function created() {
	this.loadData();
}

function closeModal() {
	this.transferSelected = null;
	this.modalData = [];
	this.sortDirectionToDetail = null;
	this.sortFieldToDetail = null;
	this.searchToDetail = null;
	this.dialog = false;
}

function columnSortableEvent(_ref2) {
	var id = _ref2.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id && columnSingle.isSortable) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function openDialog(transfer) {
	this.transferSelected = transfer;
	this.loadModalData(transfer);
	this.dialog = true;
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function searchOnDetail(search) {
	this.searchToDetail = search;
	this.loadModalData(this.transferSelected);
}

function setDialogState(id, state) {
	this.rows = this.rows.map(function (row) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row);
		if (row.id === id) {
			newRow.dialog = state;
		}
		return newRow;
	});
}

function sortableDetail(id) {
	var self = this;
	var newColumn = self.columnsToDetails.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columnsToDetails = self.columnsToDetails.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id && columnSingle.isSortable) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.sortDirectionToDetail = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.sortFieldToDetail = newColumn[0].code;
	this.loadModalData(this.transferSelected);
}

function statusName(value) {
	var name = 'Pendiente';
	switch (value) {
		case 1:
			name = 'Pendiente';
			break;
		case 2:
			name = 'En Transcurso';
			break;
		case 3:
			name = 'Finalizado';
			break;
		default:
			name = '';
			break;
	}
	return name;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ListOfDetails: __WEBPACK_IMPORTED_MODULE_6__components_shared_ListOfDetails___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	created: created,
	data: function data() {
		return {
			columns: [{ id: 1, name: '# Transferencia', code: 'number', isSortable: { down: true, up: false } }, { id: 2, name: 'Fecha', code: 'created_at', isSortable: { down: true, up: false } }, { id: 3, name: 'Estado', code: 'status', isSortable: { down: true, up: false } }, { id: 4, name: 'Fecha de anulación', code: 'cancel_date', isSortable: { down: true, up: false } }, { id: 5, name: 'Minibar', code: 'w.name' }],
			columnsToDetails: [{ id: 1, name: 'Nombre de producto', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: 'Precio', code: 'price', isSortable: { down: true, up: false } }, { id: 3, name: 'Cantidad', code: 'quantity', isSortable: { down: true, up: false } }],
			dialog: false,
			limit: 10,
			modalData: [],
			page: 1,
			rows: [],
			search: null,
			searchToDetail: null,
			sortDirection: null,
			sortDirectionToDetail: null,
			sortField: null,
			sortFieldToDetail: null,
			totalPages: 5,
			transferSelected: null
		};
	},

	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_5__shared_filters__["b" /* parseDate */],
		statusName: statusName
	},
	methods: {
		changePage: changePage,
		closeModal: closeModal,
		columnSortableEvent: columnSortableEvent,
		loadData: loadData,
		loadModalData: loadModalData,
		openDialog: openDialog,
		searchByColumn: searchByColumn,
		searchOnDetail: searchOnDetail,
		setDialogState: setDialogState,
		sortableDetail: sortableDetail,
		undoTransfer: undoTransfer
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	name: 'transfers'
});

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function columnSortableEvent(_ref) {
	var id = _ref.id;

	this.$emit('sortable-list-detail', id);
}

function searchByColumn(search) {
	this.$emit('search-list-detail', search);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a
	},
	methods: {
		columnSortableEvent: columnSortableEvent,
		searchByColumn: searchByColumn
	},
	name: 'list-of-details',
	props: {
		columns: {
			type: Array,
			required: true,
			default: []
		},
		rows: {
			type: Array,
			required: true,
			default: []
		}
	}
});

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".options-column[data-v-52fa6bc6]{display:none}.options-column.options-column-transfers[data-v-52fa6bc6]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.options-column.options-column-transfers span[data-v-52fa6bc6]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.options-column.options-column-transfers .settings-icon[data-v-52fa6bc6]{color:#2e394b;cursor:pointer;font-size:20px}.options-column.options-column-transfers .undo-item[data-v-52fa6bc6]{cursor:pointer;height:10px;line-height:12px;margin-left:15px;margin-right:10px;width:20px}.options-column.options-column-transfers .undo-icon[data-v-52fa6bc6]{height:10px}.options-column.options-column-transfers img[data-v-52fa6bc6]{height:15px}.headline[data-v-52fa6bc6]{font-size:18px!important}.headline span[data-v-52fa6bc6]{color:red;font-size:14px}.card__text[data-v-52fa6bc6]{color:red;font-size:16px;text-align:left}.card__actions[data-v-52fa6bc6]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/transfers/List.vue"],"names":[],"mappings":"AACA,iCACE,YAAc,CACf,AACD,0DACI,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACrC,AACD,+DACM,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CAC1B,AACD,yEACM,cAAe,AACf,eAAgB,AAChB,cAAgB,CACrB,AACD,qEACM,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACjB,AACD,qEACM,WAAa,CAClB,AACD,8DACM,WAAa,CAClB,AACD,2BACE,wBAA2B,CAC5B,AACD,gCACI,UAAW,AACX,cAAgB,CACnB,AACD,6BACE,UAAW,AACX,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.options-column[data-v-52fa6bc6] {\n  display: none;\n}\n.options-column.options-column-transfers[data-v-52fa6bc6] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.options-column.options-column-transfers span[data-v-52fa6bc6] {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n}\n.options-column.options-column-transfers .settings-icon[data-v-52fa6bc6] {\n      color: #2e394b;\n      cursor: pointer;\n      font-size: 20px;\n}\n.options-column.options-column-transfers .undo-item[data-v-52fa6bc6] {\n      cursor: pointer;\n      height: 10px;\n      line-height: 12px;\n      margin-left: 15px;\n      margin-right: 10px;\n      width: 20px;\n}\n.options-column.options-column-transfers .undo-icon[data-v-52fa6bc6] {\n      height: 10px;\n}\n.options-column.options-column-transfers img[data-v-52fa6bc6] {\n      height: 15px;\n}\n.headline[data-v-52fa6bc6] {\n  font-size: 18px !important;\n}\n.headline span[data-v-52fa6bc6] {\n    color: red;\n    font-size: 14px;\n}\n.card__text[data-v-52fa6bc6] {\n  color: red;\n  font-size: 16px;\n  text-align: left;\n}\n.card__actions[data-v-52fa6bc6] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".detail-table[data-v-6796c9c2]{border:1px solid #efefef}.to-kardex[data-v-6796c9c2]{color:inherit;font-family:inherit}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/ListOfDetails.vue"],"names":[],"mappings":"AACA,+BACE,wBAA0B,CAC3B,AACD,4BACE,cAAe,AACf,mBAAqB,CACtB","file":"ListOfDetails.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.detail-table[data-v-6796c9c2] {\n  border: 1px solid #efefef;\n}\n.to-kardex[data-v-6796c9c2] {\n  color: inherit;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1399);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("03b2ae6d", content, true);

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("62ad56e8", content, true);

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1496)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1329),
  /* template */
  __webpack_require__(1656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6796c9c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table-run', {
    staticClass: "no-search-table no-selectable-table table-custom-options",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("statusName")(props.row.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.cancelDate, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouse.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right pr-2 options-column options-column-transfers",
          class: {
            'active': props.row.classActive
          }
        }, [_c('span', {
          staticClass: "options-item"
        }, [_c('v-icon', {
          staticClass: "settings-icon material-icons icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openDialog(props.row)
            }
          }
        }, [_vm._v("list")])], 1), _vm._v(" "), _c('div', {
          staticClass: "undo-item"
        }, [(props.row.showUndo) ? _c('v-icon', {
          staticClass: "undo-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.setDialogState(props.row.id, true)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\tundo\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "width": "351"
          },
          model: {
            value: (props.row.dialog),
            callback: function($$v) {
              props.row.dialog = $$v
            },
            expression: "props.row.dialog"
          }
        }, [_c('v-card', [_c('v-card-title', {
          staticClass: "headline pb-0"
        }, [_vm._v("¿Está seguro de anular la transacción #" + _vm._s(props.row.number) + "?")]), _vm._v(" "), _c('v-card-text', {
          staticClass: "pt-0"
        }, [_vm._v("*Este proceso es irreversible")]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "pb-3"
        }, [_c('v-btn', {
          staticClass: "btn-save mr-2",
          nativeOn: {
            "click": function($event) {
              _vm.setDialogState(props.row.id, false)
            }
          }
        }, [_vm._v("No anular")]), _vm._v(" "), _c('v-btn', {
          staticClass: "btn-cancel ml-2",
          nativeOn: {
            "click": function($event) {
              _vm.undoTransfer(props.row)
            }
          }
        }, [_vm._v("Anular")])], 1)], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pb-4 px-3"
  }, [(_vm.transferSelected) ? _c('v-card-title', {
    staticClass: "headline px-0"
  }, [_vm._v("\n\t\t\t\tLa transferencia #" + _vm._s(_vm.transferSelected.number) + " se realizó en la fecha " + _vm._s(_vm._f("parseDate")(_vm.transferSelected.createdAt)) + "\n\t\t\t\tal minibar: " + _vm._s(_vm.transferSelected.warehouse.name) + "\n\t\t\t\t"), _c('v-icon', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), (_vm.transferSelected.cancelDate) ? _c('span', [_vm._v("\n\t\t\t\t\tTransferencia anulada el día " + _vm._s(_vm._f("parseDate")(_vm.transferSelected.cancelDate)) + "\n\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('list-of-details', {
    attrs: {
      "columns": _vm.columnsToDetails,
      "rows": _vm.modalData
    },
    on: {
      "sortable-list-detail": _vm.sortableDetail,
      "search-list-detail": _vm.searchOnDetail
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1656:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table-run', {
    staticClass: "no-selectable-table detail-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('router-link', {
          staticClass: "to-kardex",
          attrs: {
            "to": {
              name: 'kardex',
              params: {
                productId: props.row.id,
                productName: props.row.name
              }
            }
          }
        }, [_vm._v("\n\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1484)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1318),
  /* template */
  __webpack_require__(1636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52fa6bc6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/52.306714df7b9d03d1202c.js